import { FunctionComponent, ReactElement } from "react";
import { LoadingOutlined } from "@ant-design/icons";

interface Props {
  className?: string;
}
const Loader: FunctionComponent<Props> = ({ className }): ReactElement => {
  return (
    <div className={`Loader ${className ?? ""}`}>
      <LoadingOutlined />
    </div>
  );
};

export default Loader;
